import styled from 'styled-components';

const SemiBold = styled.span`
  font-weight: 600;
`;

export const Styled = {
  SemiBold,
};
